import { webApiWithResponse } from "../../../../../core/http/httpThunks";
import { AttributeValue } from "../../types";

export const createAttributeApi = (userId: string, value: AttributeValue) =>
	webApiWithResponse<string>({
		method: "PUT",
		url: "listing/newattrval",
		params: {
			userId
		},
		data: value
	});

export default createAttributeApi;
